module.exports = __webpack_public_path__ + "media/ss_photos/ss-overview-photo-01-b51bb76e.webp";